// Behaviour of the product-buy primitive (snippets/product-buy.liquid): quantity
// stepper and variant switching. Loaded by the layout on product pages only.
// Targets exclusively the contractual data-* hooks (contracts/snippets/product-buy.md)
// so a per-store fork of its markup inherits this behaviour untouched.

document.querySelectorAll('[data-qty]').forEach((qty) => {
  const input = qty.querySelector('input[name="quantity"]');
  if (!input) return;
  qty.addEventListener('click', (evt) => {
    const btn = evt.target.closest('button[data-qty-step]');
    if (!btn) return;
    const step = parseInt(btn.dataset.qtyStep, 10);
    const next = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + step));
    input.value = next;
  });
});

document.querySelectorAll('[data-buy-form]').forEach((form) => {
  const dataEl = form.querySelector('[data-variants]');
  if (!dataEl) return;
  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const selects = Array.from(form.querySelectorAll('select[data-option-index]'))
    .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex);
  if (!selects.length) return;

  const idInput = form.querySelector('input[name="id"]');
  const card = form.querySelector('[data-buy-card]');
  const priceEl = form.querySelector('[data-buy-price]');
  const stockEl = form.querySelector('[data-buy-stock]');
  const btn = form.querySelector('[data-buy-submit]');
  const label = form.querySelector('[data-buy-label]');

  const setStock = (state, text) => {
    if (!stockEl) return;
    stockEl.dataset.state = state;
    stockEl.textContent = text;
  };

  const update = () => {
    const chosen = selects.map((s) => s.value);
    const variant = variants.find((v) =>
      v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
    );
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    if (priceEl) {
      priceEl.innerHTML = variant.on_sale
        ? '<s>' + variant.compare_html + '</s> ' + variant.price_html
        : variant.price_html;
    }

    // "À paraître" is a product-level state (future publication date) — it
    // overrides the per-variant stock copy with the pre-order treatment.
    if (card && card.dataset.upcoming === 'true') {
      setStock('warn', card.dataset.i18nUpcoming);
      if (btn) {
        btn.disabled = !variant.available;
        btn.toggleAttribute('data-buy-order', variant.available);
        if (label) label.textContent = variant.available ? card.dataset.i18nPreorder : card.dataset.i18nUnavailable;
      }
      return;
    }

    if (!variant.available) {
      setStock('out', card.dataset.i18nOut);
    } else if (variant.backorder) {
      setStock('warn', card.dataset.i18nOnorder);
    } else {
      setStock('ok', card.dataset.i18nInstock);
    }

    if (btn) {
      btn.disabled = !variant.available;
      btn.toggleAttribute('data-buy-order', !!variant.backorder && variant.available);
      if (label) {
        label.textContent = !variant.available
          ? card.dataset.i18nUnavailable
          : variant.backorder ? card.dataset.i18nOrder : card.dataset.i18nAdd;
      }
    }
  };

  selects.forEach((s) => s.addEventListener('change', update));
});
